import { TaskTypeBlock } from "../../TaskTypeBlock";
import styles from "../../Block.module.scss";
import brainIcon from "./icons/brain.png";
import { AppContext } from "../../../../components/Menu/MenuButton";
import { useNavigate } from "../../../../hooks/navigate";
import { useSelector } from "../../../../hooks";
import { getTimeLeft } from "../../../../utils/time";
import { isQuizAllowedToStart } from "../../../../utils/quiz-task";
import { ActionPromptType } from "../../../../hooks/prompts";

export const QuizBlock = () => {
    const navigate = useNavigate();
    const quizTask = useSelector(store => store.tasks.quizTask);

    if (!quizTask)
        return <></>;

    const isAllowToPerform = () => isQuizAllowedToStart(quizTask.allowDate);

    const getDescription = () => {
        const isAllow = isAllowToPerform();
        if (isAllow)
            return `Доступно`;

        return <>Доступно через <span className={styles.waitingTime}>{ getTimeLeft(quizTask.allowDate, -1) }</span></>;
    }

    return (
            <TaskTypeBlock
                handler={ isAllowToPerform() ? () => navigate(AppContext.Quiz) : undefined }
                name='Участвовать в викторине'
                icon={ brainIcon }
                description={ getDescription() }
                iconTypeStyle='iconTypeQuiz'
                promptType={ ActionPromptType.PASS_QUIZ_FIRST_TIME }
            />
        
    );
};
